export const COUNTRIES = [
  'Австралия',
  'АСЕАН',
  'Бангладеш',
  'Бруней Даруссалам',
  'Восточный Тимор',
  'Вьетнам',
  'Гонконг',
  'ЕАЭС',
  'Евросоюз',
  'Индия',
  'Индонезия',
  'Камбоджа',
  'Канада',
  'Китай',
  'КНДР',
  'Лаос',
  'Макао',
  'Малайзия',
  'Мексика',
  'Монголия',
  'Мьянма',
  'Новая Зеландия',
  // 'Острова Кука',
  'Пакистан',
  'Папуа-Новая Гвинея',
  'Перу',
  'Республика Корея',
  'Россия',
  'Сингапур',
  'США',
  'Тайвань',
  'Таиланд',
  'Филиппины',
  'Чили',
  'Шри-Ланка',
  'Япония'
];

export const ASEAN_COUNTRIES = [
  'Бруней Даруссалам',
  'Вьетнам',
  'Камбоджа',
  'Лаос',
  'Индонезия',
  'Малайзия',
  'Мьянма',
  'Сингапур',
  'Таиланд',
  'Филиппины',
  
];

export const EAES_COUNTRIES = [
  'Россия'
];
